export class DayCell {

  public day: Date;
  public otherMonth: boolean = false;
  public selected: boolean = false;
  public today: boolean = false;

  constructor(day: Date) {
    this.day = day;
  }

  public dayNumber() {
    return this.day.getDate();
  }

}
